import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableView = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M22.5 9H2.5V19C2.5 19.5523 2.94772 20 3.5 20L21.5 20C22.0523 20 22.5 19.5523 22.5 19V9Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path d="M22.5 4H2.5V9L22.5 9V4Z" fill="#2D425B" fillOpacity="0.1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50503 3H15.0025H21.0004C21.8288 3 22.5004 3.67159 22.5004 4.50003L22.5 19.5C22.5 20.3284 21.8284 21 21 21H4.0015C3.17374 21 2.50224 20.3295 2.50161 19.5015C2.49903 16.0799 2.50008 12.4915 2.50112 8.97007L2.50112 8.96996L2.50112 8.96984L2.50117 8.78405C2.50041 8.7728 2.50003 8.76145 2.50003 8.75C2.50003 8.73846 2.50042 8.72701 2.50119 8.71566C2.50161 7.29337 2.50201 5.88295 2.50215 4.49986C2.50223 3.67143 3.17382 3 4.0022 3H7.50473C7.50483 3 7.50493 3 7.50503 3ZM8.00348 8.25L8.00474 4H14.5025V8.25L8.00348 8.25ZM7.00348 8.25L3.50133 8.25C3.50169 6.98569 3.50202 5.73205 3.50215 4.49996C3.50218 4.22383 3.72601 4 4.0022 4H7.00474L7.00348 8.25ZM7.00318 9.25L7.0017 14.25H3.50001C3.50008 12.5862 3.50055 10.9114 3.50103 9.25L7.00318 9.25ZM8.0017 14.25L8.00318 9.25L14.5025 9.25V14.25H8.0017ZM7.00141 15.25H3.50002C3.50011 16.6841 3.50056 18.1062 3.50161 19.5007C3.50182 19.7765 3.72546 20 4.0015 20H7C7 20 7 19.9999 7 19.9999L7.00141 15.25ZM8 20L8.00141 15.25H14.5025V20H8ZM15.5025 4V8.25L21.5003 8.25L21.5004 4.50001C21.5004 4.22387 21.2765 4 21.0004 4H15.5025ZM15.5025 9.25V14.25H21.5001L21.5003 9.25L15.5025 9.25ZM15.5025 15.25V20H21C21.2762 20 21.5 19.7761 21.5 19.5L21.5001 15.25H15.5025Z"
        fill={color}
      />
    </svg>
  )
})

export default TableView
